import { render, staticRenderFns } from "./IconSvgPencil2.vue?vue&type=template&id=6975179a&scoped=true&"
import script from "./IconSvgPencil2.vue?vue&type=script&lang=js&"
export * from "./IconSvgPencil2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975179a",
  null
  
)

export default component.exports